// constants
import * as filtersTypes from "../constants/services.constants";

const startOfWeekMonday = date => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = (day + 6) % 7;
  d.setDate(d.getDate() - diff);
  d.setHours(0, 0, 0, 0);
  return d;
};

const endOfWeekSunday = date => {
  const d = startOfWeekMonday(date);
  d.setDate(d.getDate() + 6);
  d.setHours(23, 59, 59, 999);
  return d;
};

const startOfMonth = date => {
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
};

const endOfMonth = date => {
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
};

const startOfYear = date => {
  const d = new Date(date);
  return new Date(d.getFullYear(), 0, 1, 0, 0, 0, 0);
};

const endOfYear = date => {
  const d = new Date(date);
  return new Date(d.getFullYear(), 11, 31, 23, 59, 59, 999);
};

export const DATE_PRESET_TODAY = "today";
export const DATE_PRESET_THIS_WEEK = "this_week";
export const DATE_PRESET_NEXT_WEEK = "next_week";
export const DATE_PRESET_THIS_MONTH = "this_month";
export const DATE_PRESET_NEXT_MONTH = "next_month";
export const DATE_PRESET_THIS_YEAR = "this_year";
export const DATE_PRESET_CUSTOM = "custom";

export const datePresets = [
  {
    value: DATE_PRESET_TODAY,
    title: "Today",
    range: () => {
      const d = new Date();
      return { from: d, to: d };
    }
  },
  {
    value: DATE_PRESET_THIS_WEEK,
    title: "This Week",
    range: () => {
      const now = new Date();
      return { from: startOfWeekMonday(now), to: endOfWeekSunday(now) };
    }
  },
  {
    value: DATE_PRESET_NEXT_WEEK,
    title: "Next Week",
    range: () => {
      const now = new Date();
      const nextMonday = startOfWeekMonday(now);
      nextMonday.setDate(nextMonday.getDate() + 7);
      const nextSunday = new Date(nextMonday);
      nextSunday.setDate(nextSunday.getDate() + 6);
      nextSunday.setHours(23, 59, 59, 999);
      return { from: nextMonday, to: nextSunday };
    }
  },
  {
    value: DATE_PRESET_THIS_MONTH,
    title: "This Month",
    range: () => {
      const now = new Date();
      return { from: startOfMonth(now), to: endOfMonth(now) };
    }
  },
  {
    value: DATE_PRESET_NEXT_MONTH,
    title: "Next Month",
    range: () => {
      const now = new Date();
      const firstNext = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        1,
        0, 0, 0, 0
      );
      const lastNext = new Date(
        now.getFullYear(),
        now.getMonth() + 2,
        0,
        23, 59, 59, 999
      );
      return { from: firstNext, to: lastNext };
    }
  },
  {
    value: DATE_PRESET_THIS_YEAR,
    title: "This Year",
    range: () => {
      const now = new Date();
      return { from: startOfYear(now), to: endOfYear(now) };
    }
  },
  {
    value: DATE_PRESET_CUSTOM,
    title: "Custom",
    range: null
  }
];

export const DATE_MODE_ACTIVE = "active";
export const DATE_MODE_STARTED = "started";
export const DATE_MODE_WITHIN = "within";

export const dateModeOptions = [
  { value: DATE_MODE_ACTIVE, title: "Active during" },
  { value: DATE_MODE_STARTED, title: "Started during" },
  { value: DATE_MODE_WITHIN, title: "Started and finished within" }
];

export const dateModeHints = {
  [DATE_MODE_ACTIVE]:
    "*Services active at any point during this period",
  [DATE_MODE_STARTED]:
    "*Services that started within this period (regardless of end)",
  [DATE_MODE_WITHIN]:
    "*Services that began and completed within this period"
};

export const SORT_BY_STATUS = "by_status";
export const SORT_CREATED_NEWEST = "created_newest";
export const SORT_DATE_EARLIEST = "date_earliest";
export const SORT_DATE_LATEST = "date_latest";
export const SORT_UNASSIGNED_FIRST = "unassigned_first";

export const sortOptions = [
  { value: SORT_CREATED_NEWEST, title: "Created (newest)" },
  { value: SORT_DATE_EARLIEST, title: "Date earliest" },
  { value: SORT_DATE_LATEST, title: "Date latest" },
  { value: SORT_UNASSIGNED_FIRST, title: "Unassigned first" },
  { value: SORT_BY_STATUS, title: "By status" }
];

export const presets = [
  {
    title: "Active",
    value: filtersTypes.PRESET_ACTIVE,
    statuses: [
      filtersTypes.FILTERS_ACCEPTED,
      filtersTypes.FILTERS_IN_PROGRESS,
      filtersTypes.FILTERS_PAUSED
    ]
  },
  {
    title: "Done",
    value: filtersTypes.PRESET_DONE,
    statuses: [filtersTypes.FILTERS_FINISHED, filtersTypes.FILTERS_CANCELED]
  },
  {
    title: "All",
    value: filtersTypes.PRESET_ALL,
    statuses: []
  }
];

export const statusFilters = [
  { label: "Pending", value: filtersTypes.FILTERS_ACCEPTED, key: "pending" },
  { label: "In Progress", value: filtersTypes.FILTERS_IN_PROGRESS, key: "in_progress" },
  { label: "Paused", value: filtersTypes.FILTERS_PAUSED, key: "paused" },
  { label: "Completed", value: filtersTypes.FILTERS_FINISHED, key: "completed" },
  { label: "Cancelled", value: filtersTypes.FILTERS_CANCELED, key: "cancelled" }
];

export const tableHeadBuilder = [
  { title: "ID", className: "ID" },
  { title: "Status", className: "status" },
  { title: "Start", className: "start" },
  { title: "Finish", className: "finish" },
  { title: "User", className: "user" },
  { title: "Service Type", className: "serviceType" },
  { title: "Truck", className: "truck" },
  { title: "Trailer", className: "trailer" },
  { title: "Workers", className: "workers" }
];
